import { useCallback, useState } from "react";
import SideBar from "../pages/sidebar/SideBar";
import ProtectedRoute from "../hoc/ProtectedRoutes";
import RoutePermissionGuard from "../hoc/RoutePermissionGuard";
import { PermissionProvider } from "../helper/PermissionContext";

const AdminLayout = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = useCallback(() => {
    setIsOpen((prevState) => !prevState);
  }, []);

  return (
    <>
      <ProtectedRoute>
        <PermissionProvider>
          <SideBar isOpen={isOpen} toggleSidebar={toggleSidebar} />
          <main className={`admin-main ${isOpen ? "close" : "open"}`}><RoutePermissionGuard /></main>
        </PermissionProvider>
      </ProtectedRoute>
    </>
  );
};

export default AdminLayout;
